import styled from 'styled-components';

export const ContentLeft = styled.aside`
  display: flex;
  flex-direction: column;
  width: 50%;
  border-right: 1px solid ${props => props.theme.colors.cardContainerEvolutiveCross};
  padding-right: 24px;

  .titleWrapper {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }

  .leftTitle {
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    margin: 0 0 0 8px;
    color: ${props => props.theme.colors.text.default};
  }
`;

export const CounterContainer = styled.div`
  background-color: ${({theme}) => theme.colors.backgroundColorHeader};
  width: 100%;
  max-width: 620px;
  height: 51px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  padding-left: 24px;

  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  font-variant: all-small-caps;
  color: ${({theme}) => theme.colors.cartTitleColor};
`;